module.exports = __webpack_public_path__ + "img/1378794662.db0d34ea.jpg";